module.exports = __webpack_public_path__ + "img/browser_circle.f17988a2.svg";